export default __webpack_public_path__ + "static/media/gold-chain.d8aef33b.png";